module.exports = __webpack_public_path__ + "img/holdCourt1.99666db9.svg";